(() => {
  'use strict';
  if (customElements.get('octulos-product-assistant-controller')) return;
  class AssistantController extends HTMLElement {}
  customElements.define('octulos-product-assistant-controller', AssistantController);
  const setup = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-question-form]');
    const input = form.elements.question;
    const status = root.querySelector('[data-status]');
    const conversation = root.querySelector('[data-conversation]');
    const endpoint = root.dataset.endpoint;
    let busy = false;
    let history = [];
    const offline = 'The preview is ready. AI answers will be available once the connection is activated.';
    const message = (role, text) => {
      const p = document.createElement('p');
      p.className = `octulos-assistant__message octulos-assistant__message--${role}`;
      const label = document.createElement('strong');
      label.textContent = role === 'user' ? 'YOU' : 'OCTULOS';
      p.append(label, document.createTextNode(text));
      conversation.append(p);
      // Keep long visits bounded; only the last three exchanges are sent.
      while (conversation.children.length > 20) conversation.firstElementChild.remove();
      conversation.scrollTop = conversation.scrollHeight;
    };
    const request = async (path, options = {}) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(endpoint + path, { ...options, signal: controller.signal, headers: { 'Content-Type': 'application/json' }, cache: 'no-store' });
        if (!response.ok) {
          const error = new Error('request');
          error.status = response.status;
          throw error;
        }
        const data = await response.json();
        if (data.ok === false) {
          const error = new Error('service');
          error.status = data.code;
          throw error;
        }
        return data;
      } finally { clearTimeout(timer); }
    };
    request('/status').then(data => { if (!busy) status.textContent = data.ready ? '' : offline; }).catch(() => { if (!busy) status.textContent = 'The assistant is temporarily unavailable. Please try again later.'; });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const question = input.value.trim();
      if (busy || !question || question.length > 600) return;
      busy = true;
      root.querySelectorAll('button').forEach(b => { b.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Processing your question…';
      message('user', question);
      input.value = '';
      try {
        const data = await request('/ask', { method: 'POST', body: JSON.stringify({ handle: root.dataset.handle, question, history }) });
        message('assistant', data.answer);
        history = [...history, { role: 'user', content: question }, { role: 'assistant', content: data.answer }].slice(-6);
        if (Array.isArray(data.sources)) {
          const sources = document.createElement('div');
          sources.className = 'octulos-assistant__sources';
          data.sources.forEach(source => {
            if (!/^\/policies\/[a-z0-9-]+$/.test(source.url)) return;
            const link = document.createElement('a');
            link.href = source.url;
            link.textContent = 'Shipping';
            sources.append(link);
          });
          if (sources.childElementCount) conversation.append(sources);
          conversation.scrollTop = conversation.scrollHeight;
        }
        status.textContent = 'You can ask a follow-up question.';
      } catch (error) {
        status.textContent = error.status === 503 ? offline : error.status === 429 ? 'The question limit has been reached. Please try again later.' : 'Your question could not be answered. Please try again later.';
        input.value = question;
      } finally {
        busy = false;
        form.removeAttribute('aria-busy');
        root.querySelectorAll('button').forEach(b => { b.disabled = false; });
        input.focus({ preventScroll: true });
      }
    });
    root.querySelectorAll('[data-question]').forEach(button => button.addEventListener('click', () => {
      input.value = button.textContent.trim();
      form.requestSubmit();
    }));
  };
  const init = () => document.querySelectorAll('[data-product-assistant]').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();
